import React, { useEffect, useState  , useRef } from 'react';
import FabricQualityService from '../../services/fabric-quality.service';
import './fabric-quality-list.scss';
import AuditTableInput from '../audit-table/audit-table';
import HardDelete from '../hard-delete/hard-delete';

import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import FabricQualityAdd from './fabric-quality-add';
import FabricQualityEdit from './fabric-quality-edit';
// import YarnPurchaseContractEdit from './yarn-purchase-contract-edit';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import SecurityService from '../security/security.service';
// import YarnContractDeliveryScheduleList from '../yarn-contract-delivery-schedule/yarn-contract-delivery-schedule-list';
import moment from 'moment';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import CommonService from '../../services/common.service';
let selectedRows = []
export default function FabricQualityList(props) {
  const [fabricQuality, setFabricQualitys] = useState([]);
  // const [showDialog, setShowDialog] = useState(false);
  // const [selectedRow, setSelectedRow] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [values, setValues] = useState();
  const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const deleteDialog = useRef();
  const warningDialog = useRef();
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();
  const [deletingID, setDeletingID] = useState(0);
  let fabricQualityGrid: Grid;

  const UserId = SecurityService.getLoggedInUserId();

  const userId = SecurityService.getLoggedInUserId();
  const toolbarClick = (args: ClickEventArgs) => {
    console.log('args.item.properties :', args.item.properties);
    if (
      fabricQualityGrid &&
      args.item.properties.id === 'fabricQualityGrid_PDFExport'
    ) {
      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_fabric_quality.pdf`
      };
      console.log('clicked on pdf export');
      fabricQualityGrid.pdfExport(exportProperties);
    }
    if (
      fabricQualityGrid &&
      args.item.properties.id === 'fabricQualityGrid_excelexport'
    ) {
      const exportProperties: PdfExportProperties = {
        fileName: `${moment().format('YYYYMMDD')}_fabric_quality.xlsx`
      };
      fabricQualityGrid.excelExport(exportProperties);
    }
    if (
      fabricQualityGrid &&
      args.item.properties.id === 'fabricQualityGrid_columnchooser'
    ) {
    }
    if (fabricQualityGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (fabricQualityGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', fabricQualityGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        let obj={
          TableName:`ProcessDesc`,
          ColumnName:`ProcessDescID`,
          RowID:undefined,
          SelectedRow:false,
          UserID:UserId,
          // DeleteSecurity:`ProcessDescDelete`
          
        }
        setDeletingProps(obj)
        setShowDialogs(true)
       
      } else {
        console.log('delete: ', fabricQualityGrid.getSelectedRecords()[0]?.ProcessDescID)
        // deleteDialog.current.hide();
        let obj={
          TableName:`FabricQuality`,
          ColumnName:`FabricQualityID`,
          RowID:fabricQualityGrid.getSelectedRecords()[0]?.FabricQualityID,
          SelectedRow:true,
          UserID:UserId,
          DeleteSecurity:`FabricQualityDelete`,
          SelectedRowData :{
            FabricTypeID:fabricQualityGrid.getSelectedRecords()[0].FabricTypeID,
            WarpFullYarnCountID: fabricQualityGrid.getSelectedRecords()[0].WarpFullYarnCountID,	
            WeftFullYarnCountID: fabricQualityGrid.getSelectedRecords()[0].WeftFullYarnCountID,	
            Ends: fabricQualityGrid.getSelectedRecords()[0].Ends,	
            Picks: fabricQualityGrid.getSelectedRecords()[0].Picks,	
            Width	: fabricQualityGrid.getSelectedRecords()[0].Width,
            PickYarnThread: fabricQualityGrid.getSelectedRecords()[0].PickYarnThread,	
            FabricThreadCountID: fabricQualityGrid.getSelectedRecords()[0].FabricThreadCountID,	
            FabricQualityDesc: fabricQualityGrid.getSelectedRecords()[0].FabricQualityDesc,	
            FabricYarnDescID: fabricQualityGrid.getSelectedRecords()[0].FabricYarnDescID,	
            FabricCategoryID: fabricQualityGrid.getSelectedRecords()[0].FabricCategoryID,	
            HSCodeID: fabricQualityGrid.getSelectedRecords()[0].HSCodeID,	
              }
          
          
          
          }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    } 
    


    // if (
    //   fabricQualityGrid &&
    //   args.item.properties.id === 'fabricQualityGrid_Delivery Schedule'
    // ) {
    //   console.log('clicked delivery');
    // }
  };

  useEffect(() => {
    // const type = getRoute()[1];
    getFabricQualitys();
  }, []);

  const getFabricQualitys = async () => {
    FabricQualityService.getForList()
      .then((response) => {
        console.log('all fabric quality response', response.data.recordset)
        setFabricQualitys(response.data.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // const addYarnContract = () => {
  //   props.history.push('/YarnContract/Purchase/Add');
  // };

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

  const toolbarOptions: ToolbarItems[] = [
    "Add",
    "Edit",
    {
      text: "Delete", tooltipText: "Delete", id: "Delete", disabled: !SecurityService.canUserAccess('FabricQualityDelete')
    },
    "Update",
    "Cancel",
    "PDFExport",
    "ExcelExport",
    "Search",
    "ColumnChooser",
  ];

  const databound = () => {
    if (fabricQualityGrid) {
      fabricQualityGrid.autoFitColumns();
    }
  }

  const dialogTemplate = (props) => {
    console.log('props: ', props);
    return props.isAdd ? (
      <FabricQualityAdd dataList={fabricQuality} {...props}> </FabricQualityAdd>
    ) : (
      <FabricQualityEdit dataList={fabricQuality} {...props}> </FabricQualityEdit>
    );
  };

  const editSettings: EditSettingsModel = {
    allowEditing: SecurityService.canUserAccess('FabricQualityEdit'),
    allowAdding: SecurityService.canUserAccess('FabricQualityAdd'),
    allowDeleting: SecurityService.canUserAccess('FabricQualityDelete'),

    // allowEditing: true,
    // allowAdding: true,
    // allowDeleting: true,

    mode: 'Dialog',
    showDeleteConfirmDialog: true,
    template: dialogTemplate,
    headerTemplate: '<p></p>'
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    columns: [
      {
        field: 'IsDeleted',
        operator: 'notequal',
        value: 'True'
      }
    ]
  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'FabricQualityID', direction: 'Descending' }]
  }

  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum}</span>;
  };

  // const header = () => {
  //   return <div>Yarn Contract Delivery Schedule</div>;
  // };

  //   const contentTemplate = () => {
  //   return (
  //     <div>
  //       <YarnContractDeliveryScheduleList
  //         {...selectedRow}
  //       ></YarnContractDeliveryScheduleList>
  //     </div>
  //   );
  // };

  const actionComplete = (args: DialogEditEventArgs) => {
    console.log('data: ', args);
    if (args?.requestType === 'columnstate') {
      console.log('adjusting column');
      fabricQualityGrid?.autoFitColumns();
    }
    if (args.form) {
      console.log('data: ', args);
      if (args.requestType === 'beginEdit' || args.requestType === 'add') {
        console.log('e: ', args.form.ej2_instances[0]);
        /** Add Validation Rules */
        // args.form.ej2_instances[0].addRules('FabricTypeID', { required: true });
        // args.form.ej2_instances[0].addRules('WarpFullYarnCountID', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('WeftFullYarnCountID', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('Ends', { required: true });
        // args.form.ej2_instances[0].addRules('Picks', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('Width', { required: true });
        // args.form.ej2_instances[0].addRules('WarpYarnQualityID', { required: true });
        // args.form.ej2_instances[0].addRules('WeftYarnQualityID', { required: true });
        // args.form.ej2_instances[0].addRules('WarpYarnThread', { required: true });
        // args.form.ej2_instances[0].addRules('WeftYarnThread', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('WarpYarnTypeID', { required: true });
        // args.form.ej2_instances[0].addRules('WeftYarnTypeID', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('PickYarnThread', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('FabricThreadCountID', {
        //   required: true,
        // });
        // args.form.ej2_instances[0].addRules('FabricQualityDesc', { required: true });
        // args.form.ej2_instances[0].addRules('FabricYarnDescID', { required: true });

        // args.form.ej2_instances[0].addRules('FabricCategoryID', { required: true });
        // args.form.ej2_instances[0].addRules('HSCodeID', { required: true });

      }

      if (args.requestType === 'save' && args.action === 'add') {

        const data= {
          ...args.data,
          UserID:userId
        }
        FabricQualityService.create(data).then((response) => {
          console.log('add response: ', response);
          console.log('data: ', args.data);
          let addData= {
        FabricTypeID:args.data.FabricTypeID,
        WarpFullYarnCountID: args.data.WarpFullYarnCountID,	
        WeftFullYarnCountID: args.data.WeftFullYarnCountID,	
        Ends: args.data.Ends,	
        Picks: args.data.Picks,	
        Width	: args.data.Width,
        PickYarnThread: args.data.PickYarnThread,	
        FabricThreadCountID: args.data.FabricThreadCountID,	
        FabricQualityDesc: args.data.FabricQualityDesc,	
        FabricYarnDescID: args.data.FabricYarnDescID,	
        FabricCategoryID: args.data.FabricCategoryID,	
        HSCodeID: args.data.HSCodeID,	
          }
          AuditTableInput.auditAdd(`FabricQuality`,`FabricQuality`,`FabricQualityID`,addData)

          fabricQualityGrid.refresh()

          getFabricQualitys();
          //const type = getRoute()[1];
          //getFabricQualitys(type);
        });
      }
      if (args.requestType === 'save' && args.action === 'edit') {
        const data = {
          ...args.data,
          UserID:userId,
        }
        FabricQualityService.update(args.data.FabricQualityID, data).then((response) => {
          console.log('add response: ', response);
          console.log('data: ', args.data);
          let editData= {
            FabricTypeID:args.data.FabricTypeID,
            WarpFullYarnCountID: args.data.WarpFullYarnCountID,	
            WeftFullYarnCountID: args.data.WeftFullYarnCountID,	
            Ends: args.data.Ends,	
            Picks: args.data.Picks,	
            Width	: args.data.Width,
            PickYarnThread: args.data.PickYarnThread,	
            FabricThreadCountID: args.data.FabricThreadCountID,	
            FabricQualityDesc: args.data.FabricQualityDesc,	
            FabricYarnDescID: args.data.FabricYarnDescID,	
            FabricCategoryID: args.data.FabricCategoryID,	
            HSCodeID: args.data.HSCodeID,	
              }
              let totalColumns =  Object.keys(editData)

              AuditTableInput.auditEdit(totalColumns,selectedRows,editData,`FabricQuality`,args.data.FabricQualityID)

              
          // setFabricQualitys(response.data.recordset);
          //const type = getRoute()[1];
          //getFabricQualitys(type);
          fabricQualityGrid.refresh()

          getFabricQualitys();
        });
      }

    }

  };

  // const commandClick = (args: CommandClickEventArgs) => {
  //   setShowDialog(false);
  //   console.log('command click args: ', args);
  //   setSelectedRow(args.rowData);
  //   setShowDialog(true);
  // };
  const deleteRow = () => {
    CommonService.delete(userId, 'FabricQualityDelete', 'FabricQuality ', 'FabricQualityID', deletingID, 1)
      .then(async (response) => {
        // setDialogWarningVisibility(false);
        // console.log("Message is about to set to ", response?.data?.recordset[0]?.Message);
        setWarningMessage(response?.data?.recordset[0]?.Message);
        // console.log("Message is set");
        warningDialog.current.show();
        // if (!(response?.data?.recordset[0]?.Message.includes('access denied'))) {
        //   // record was succesfully deleted
        //   const type = getRoute()[1];
        //   await getYarnContracts(type);
        //   // console.log("record was succesfully deleted");
        // }
        // console.log("Dialog Turned on");
      })
      .catch((e) => {
        // setWarningMessage('Error: ');
        // setDialogWarningVisibility(true);
        console.log('Error: ', e);
      });;
  };

  const deleteButtons = [
    {
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      click: (e) => {
        deleteDialog.current.hide();
        console.log(e);
        deleteRow();
      },
    },
    {
      buttonModel: {
        content: 'Cancel',
        cssClass: 'e-flat',
      },
      click: () => {
        deleteDialog.current.hide();
      },
    },
  ];

  const warningButtons = [
    {
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      click: () => {
        warningDialog.current.hide();
        // setTimeout(() => {
        //   if (!(warningMessage.includes('access denied'))) {
        //     // record was succesfully deleted
        //     const type = getRoute()[1];
        //     getYarnContracts(type);
        //     // console.log("record was succesfully deleted");
        //   }
        // }, 500);

      },
    },
  ];

  function deleteDialogClose() {
    setDeleteDialogVisibility(false);
    }

  function warningDialogClose() {
    setDialogWarningVisibility(false);
    if (!(warningMessage.includes('access denied'))) {
      // record was succesfully deleted
      const type = getRoute()[1];
getFabricQualitys(type);
      // console.log("record was succesfully deleted");
}
  }

  // const formatOptions = { type: 'date', format: 'dd/MM/yy' }

  // const openDialog = () => {
  //   setShowDialog(true);
  // };
  const thousandSeperator = (field: string, data: object, column: Column) => {
    const value = data[column.field];
    console.log(value);
    if (value) {
        let parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    }
  }

  const FabricQualityGridComponent = ({ restrictPageSize = 12 }) => (
    <GridComponent
      ref={(grid) => (fabricQualityGrid = grid)}
      id='fabricQualityGrid'
      dataSource={fabricQuality}
      editSettings={editSettings}
      toolbar={toolbarOptions}
      pageSettings={{ pageCount: 4, pageSizes: true, pageSize: restrictPageSize }}
      filterSettings={filterOptions}
      groupSettings={groupOptions}
      actionComplete={actionComplete}
      allowTextWrap='true'
      // commandClick={commandClick}

      allowPaging={true}
      allowSorting={true}
      allowPdfExport={true}
      allowExcelExport={true}
      toolbarClick={toolbarClick}
      allowFiltering={true}
      allowGrouping={true}
      showColumnChooser={true}
      allowReordering={true}
      allowResizing={true}
      // dataBound={databound}
      sortSettings={sortingOptions}
      rowSelected={
        (args)=>{
          console.log(args.data)
          selectedRows = args.data
          
                    setTimeout(() => {
            console.log('ss')
          }, 200);
        }
      }
    >
      <ColumnsDirective>
        {/* <ColumnDirective
                headerText='Commands'
                width='170'
                commands={commands}
                textAlign='Left'
              /> */}
        <ColumnDirective
          headerText='ID'
          field='FabricQualityID'
          width='90'
          textAlign='right'
          HeaderTextAlign='Center'
        />
        <ColumnDirective
          headerText='Fabric Quality'
          field='FabricQuality'
          width='200'
          HeaderTextAlign='Center'
          textAlign='Left'
        />
        {/* <ColumnDirective
                headerText='Order Date'
                field='OrderDate'
                width='200'
                
                type='date'
                format='dd/MM/yy'
              /> */}
        <ColumnDirective
          headerText='Fabric 
          Type'
          field='FabricTypeDesc'
          width='135'
          HeaderTextAlign='Center'
          textAlign='Left'
        />
        <ColumnDirective
          headerText='Thread 
          Count'
          field='FabricThreadCountDesc'
          textAlign='Left'
          width='130'
          HeaderTextAlign='Center'
        />
        <ColumnDirective
          headerText='Fabric Quality Description'
          field='FabricQualityDesc'
          width='210'
          textAlign='Left'
          HeaderTextAlign='Center'
        />
        <ColumnDirective
          headerText='Fabric Weave'
          field='FabricCategoryDesc'
          width='145'
          textAlign='Left'
          HeaderTextAlign='Center'
        />

        <ColumnDirective
          headerText='HS Code'
          field='HSCodeNo'
          width='130'
          textAlign='Left'
          HeaderTextAlign='Center'
        />
        <ColumnDirective
          headerText='Cancel'
          field='IsDeleted'
          width='130'
          HeaderTextAlign='Center'
          textAlign='Left'
        />
        {/* <ColumnDirective
                headerText='Bags Ordered'
                field='OrderBags'
                width='150'
              />
              <ColumnDirective
                headerText='Bags Weight'
                field='WeightPerBag'
                width='150'
              />
              <ColumnDirective
                headerText='Procurement Type'
                field='ProcurementType'
                width='150'
              />
              <ColumnDirective
                headerText='Start Date'
                field='ContractStartDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='End Date'
                field='ContractEndDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='Currency'
                field='CurrencyName'
                width='140'
              />
              <ColumnDirective
                headerText='Foreign Currency Rate'
                field='ForeignCurrencyRate'
                width='200'
              />
              <ColumnDirective
                headerText='Foreign Currency Amount'
                field='ForeignCurrencyAmount'
                width='200'
              />
              <ColumnDirective
                headerText='Contract Exchange Rate'
                field='ContractExchangeRate'
                width='200'
              />
              <ColumnDirective
                headerText='Bags Received'
                field='ReceivedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Bags Returned'
                field='ReturnedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Tax %'
                field='TaxPercent'
                width='100'
              />
              <ColumnDirective
                headerText='Tax Type'
                field='TaxType'
                width='150'
              /> */}
      </ColumnsDirective>

      {/* <AggregatesDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    footerTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    groupFooterTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
            </AggregatesDirective> */}

      <Inject
        services={[
          Edit,
          Toolbar,
          Page,
          Sort,
          PdfExport,
          ExcelExport,
          Filter,
          Group,
          Aggregate,
          Freeze,
          ColumnChooser,
          Reorder,
          Resize,
          // CommandColumn,
        ]}
      />
    </GridComponent>
  );

  return (
    (props.isDialog) ? (
      <div>
        <FabricQualityGridComponent restrictPageSize={5} />
      </div>
    ) :
      (
        <div className="content-wrapper">
          <div>
            <div>
              <h4>Fabric Quality - List</h4>
              <div>
                {/* <ButtonComponent onClick={addYarnContract}>Add </ButtonComponent> */}
                {/* <button
                className='m-3 btn btn-sm btn-primary'
                onClick={this.addYarnContract}
              >
                Add
              </button> */}
              </div>
              <div>
              <DialogComponent
                ref={deleteDialog}
                width={500}
                visible={deleteDialogVisibility}
                close={deleteDialogClose}
                content={() => (<div>Are you sure you want to delete?</div>)}
                isModal={true}
                header='Confirmation'
                buttons={deleteButtons}
              // footerTemplate={footerTemplate}
              />
              <DialogComponent
                ref={warningDialog}
                width={400}
                visible={dialogWarningVisibility}
                close={warningDialogClose}
                content={() => (<div>{warningMessage}</div>)}
                isModal={true}
                header='Warning'
                buttons={warningButtons}
              // footerTemplate={footerTemplate}
              />
          </div>
              {/* <div>
              <ReactDataGrid columns={columns} rows={rows} editor={true} />
            </div> */}

              {/* <div className='e-statustext'>
                  Select column name to toggle visibility
                </div> */}
              {/* <ToolbarComponent
                  id='toolbar'
                  ref={(toolbar) => (this.ToolbarInstance = toolbar)}
                  onClick={toolBarClick(this)}
                >
                  <ItemsDirective>
                    <ItemDirective text='Order ID' />
                    <ItemDirective text='Customer Name' />
                    <ItemDirective text='Freight' />
                    <ItemDirective text='Order Date' />
                    <ItemDirective text='Shipped Date' />
                    <ItemDirective text='Ship Country' />
                  </ItemsDirective>
                </ToolbarComponent> */}
              {/* <div className='App' id='dialog-target'>
            <DialogComponent
              width='600px'
              target='#dialog-target'
              visible={showDialog}
              close={dialogClose}
              content={contentTemplate}
              isModal={true}
              showCloseIcon={true}
              header={header}
              
            />
          </div> */}
           {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  
                                  getFabricQualitys();
                                }
              }} 
                ></HardDelete>
                  :null}
              <FabricQualityGridComponent />
            </div>
          </div>
        </div>
      )
  );
}
